import { useAuth } from "../../lib/auth";
import { User, Mail, Phone, LogOut } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="space-y-6" data-testid="salesman-profile">
      <div>
        <p className="overline text-[color:var(--muted)]">Profile</p>
        <h1 className="font-display text-3xl font-bold mt-1">Me</h1>
      </div>

      <div className="rounded-xl border border-[color:var(--border)] bg-white p-5">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-[color:var(--primary)]/10 text-[color:var(--primary)] flex items-center justify-center">
            <User className="h-7 w-7" />
          </div>
          <div>
            <div className="font-display text-xl font-bold">{user?.name}</div>
            <div className="text-xs text-[color:var(--muted)] uppercase tracking-widest mt-1">
              {user?.role}
            </div>
          </div>
        </div>
        <div className="mt-5 space-y-2 text-sm">
          <div className="flex items-center gap-3">
            <Mail className="h-4 w-4 text-[color:var(--muted)]" /> {user?.email}
          </div>
          {user?.phone && (
            <div className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[color:var(--muted)]" /> {user.phone}
            </div>
          )}
        </div>
      </div>

      <Button
        variant="outline"
        onClick={() => {
          logout();
          nav("/login", { replace: true });
        }}
        className="w-full h-12"
        data-testid="profile-logout-button"
      >
        <LogOut className="h-4 w-4 mr-2" /> Sign out
      </Button>
    </div>
  );
}
